import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import pwaNotificationsMobile from '@/assets/images/pwa-notifications-mobile.png'
import pwaNotificationsDesktop from '@/assets/images/pwa-notifications-desktop.png'

import pwaNotificationsDesktopStandaloneFirst from '@/assets/images/pwa-notifications-desktop-standalone-1.png'
import pwaNotificationsDesktopStandaloneSecond from '@/assets/images/pwa-notifications-desktop-standalone-2.png'
import pwaNotificationsMobileStandalone from '@/assets/images/pwa-notifications-mobile-standalone.png'

import IsStandalone from '@/mixins/is-standalone.js'
import IsChromeDesktop from '@/mixins/is-chrome-desktop.js'
import IsChromeAndroid from '@/mixins/is-chrome-android.js'
// import IsFirefoxDesktop from "@/mixins/is-firefox-desktop.js";

export default {
  name: 'NotificationBlockedReminderModal',
  extends: BaseModal,
  mixins: [
    IsStandalone,
    IsChromeDesktop,
    IsChromeAndroid,
    // IsFirefoxDesktop
  ],
  computed: {
    href() {
      return window.location.href
    },
  },
  data: function () {
    return {
      pwaNotificationsMobile,
      pwaNotificationsDesktop,
      pwaNotificationsDesktopStandaloneFirst,
      pwaNotificationsDesktopStandaloneSecond,
      pwaNotificationsMobileStandalone,
    }
  },
  methods: {},
}
